module.exports = __webpack_public_path__ + "static/media/logo.c76e0121.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/images/logo.png
// module id = 179
// module chunks = 0